import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M21.14 9.9h-8.39v5.48c0 .41-.34.75-.75.75s-.75-.34-.75-.75V9.9H2.86c-.48 0-.86.38-.86.86 0 5.89 4.11 10 10 10s10-4.11 10-10c0-.48-.38-.86-.86-.86" }, null, -1),
    _createElementVNode("path", { d: "m12.75 5.8 1.56 1.56c.29.29.77.29 1.06 0s.29-.77 0-1.06l-2.85-2.84a.754.754 0 0 0-1.06 0L8.62 6.31c-.14.15-.22.34-.22.53s.07.38.22.53c.29.29.77.29 1.06 0l1.56-1.56V9.9h1.5V5.8z" }, null, -1)
  ]))]))
}
export default { render: render }